export enum PortfolioSolutionsEnum {
  DETTE = "DETTE",
  PROSPECTIVE = "PROSPECTIVE",
  DETTE_ET_PROSPECTIVE = "DETTE_ET_PROSPECTIVE"
}
